import React from 'react';
import { useSessions } from '../../hooks/useSessions';
import { SessionLiveBanner } from './SessionLiveBanner';

/**
 * Live presenting/voting bar shown at the top of hackathon pages. Every hackathon has at least one
 * session, so this is the compact per-room bar.
 */
export const LiveVotingBanner = ({ hackathonId }: { hackathonId: string }) => {
    const { sessions } = useSessions(hackathonId);
    if (sessions.length === 0) {
        return null;
    }
    return <SessionLiveBanner hackathonId={hackathonId} sessions={sessions} />;
}
